import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { FileUpload } from 'primereact/fileupload';
import { data } from 'autoprefixer';
import { Panel } from 'primereact/panel';
import { FloatLabel } from 'primereact/floatlabel';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import Employees from '../employees/Employees';
import { employeesAPI } from '../../services/employeesService';
import { InputTextarea } from 'primereact/inputtextarea';

const AdmissionFormDialog = ({
  visible,
  onHide,
  editingAdmission,
  admissionForm,
  setAdmissionForm,
  genderOptions,
  classes,
  parents,
  coupons,
  handleCreateParent,
  handleSaveAdmission,
  convertToBase64,
  loading,
  toast,
  employees,
  referralOptions
}) => {



  return (
    <Dialog header={editingAdmission ? 'Edit Admission' : 'Admit New Student'} visible={visible} onHide={onHide} style={{ width: '750px' }} footer={(
      <div style={{ textAlign: 'center' }} >
        <Button label="Cancel" onClick={onHide} disabled={loading} style={{ width: '150px', height: '50px', marginRight: '5px', backgroundColor: 'red', color: 'whitesmoke' }} />
        <Button label={loading ? 'Loading' : (editingAdmission ? 'Update' : 'Save Student')} onClick={handleSaveAdmission} loading={loading} style={{ width: '150px', height: '50px', marginLeft: '5px', backgroundColor: 'rebeccapurple', color: 'whitesmoke' }} />
      </div>
    )}>
      <div >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ marginTop: "25px", marginBottom: "25px" }}>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <InputText id="fullName" value={admissionForm.fullName} onChange={(e) => setAdmissionForm({ ...admissionForm, fullName: e.target.value })} />
              <label htmlFor="fullName">Full Name</label>
            </FloatLabel>
          </div>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Dropdown value={admissionForm.classId} options={classes.map(c => ({ label: c.name, value: c.id }))} onChange={(e) => setAdmissionForm({ ...admissionForm, classId: e.value })}
                placeholder="Select class" className="w-full" required disabled={loading} style={{ width: "260px" }} />
              <label htmlFor="class">Class</label>
            </FloatLabel>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ marginBottom: "25px", marginTop: "15px" }}>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Calendar inputId="date_birth" value={admissionForm.dateOfBirth} onChange={(e) => setAdmissionForm({ ...admissionForm, dateOfBirth: e.value })} style={{ width: "260px" }} />
              <label htmlFor="date_birth">Date of Birth</label>
            </FloatLabel>
          </div>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Dropdown value={admissionForm.gender} options={genderOptions} onChange={(e) => setAdmissionForm({ ...admissionForm, gender: e.value })}
                placeholder="Select gender" className="w-full" required disabled={loading} style={{ width: "260px" }} />
              <label htmlFor="gender">Gender</label>
            </FloatLabel>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ marginBottom: "25px", marginTop: "15px" }}>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <InputTextarea id="healthIssues" value={admissionForm.healthIssues} onChange={(e) => setAdmissionForm({ ...admissionForm, healthIssues: e.target.value })} style={{ width: "260px" }} />
              <label htmlFor="healthIssues">Health Issues</label>
            </FloatLabel>
          </div>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Dropdown value={admissionForm.bloodGroup}
                options={[
                  { label: 'A+', value: 'A+' },
                  { label: 'A-', value: 'A-' },
                  { label: 'B+', value: 'B+' },
                  { label: 'B-', value: 'B-' },
                  { label: 'AB+', value: 'AB+' },
                  { label: 'AB-', value: 'AB-' },
                  { label: 'O+', value: 'O+' },
                  { label: 'O-', value: 'O-' }
                ]}
                onChange={(e) => setAdmissionForm({ ...admissionForm, bloodGroup: e.value })} placeholder="Select bloodgroup" className="w-full" style={{ width: "260px" }} showClear />
              <label htmlFor="bloodGroup">Blood Group</label>
            </FloatLabel>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ marginBottom: "25px", marginTop: "15px" }}>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Calendar value={admissionForm.admissionDate} onChange={(e) => setAdmissionForm({ ...admissionForm, admissionDate: e.value })} showIcon dateFormat="dd-mm-yy" className="w-full text-sm border border-gray-200 rounded-lg" style={{ width: "260px" }} disabled={loading} />
              <label htmlFor="admissionDate">Admission Date</label>
            </FloatLabel>
          </div>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Dropdown value={admissionForm.parentId} options={parents.map(data => ({ label: data.name, value: data.id }))}
                onChange={(e) =>
                  setAdmissionForm({ ...admissionForm, parentId: e.value })
                }
                placeholder="Select parent" className="w-full" required style={{ width: "200px" }} />
              <label htmlFor="parent">Parent</label>
            </FloatLabel>
            <div >
              <Button tooltip='Add Parent' label="Add" onClick={handleCreateParent} style={{ backgroundColor: "blue", color: "whitesmoke", margin: '5px', width: '60px', height: '50px' }} />
            </div></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ marginBottom: "25px", marginTop: "15px" }}>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <Dropdown value={admissionForm.referralType} options={referralOptions} onChange={(e) => setAdmissionForm({ ...admissionForm, referralType: e.value })}
                placeholder="Select Referral" className="w-full" required disabled={loading} style={{ width: "260px" }} />
              <label >Referral</label>
            </FloatLabel>
          </div>
          {admissionForm.referralType === 'employee' && (
            <div className="card flex justify-content-center">
              <FloatLabel>
                <Dropdown value={admissionForm.admissionerId} options={employees.map(data => ({ label: data.firstName + " " + data.lastName, value: data.id }))} onChange={(e) => setAdmissionForm({ ...admissionForm, addmissionerId: e.value })}
                  placeholder="Select Employee" className="w-full" required disabled={loading} style={{ width: "260px" }} />
                <label >Staff</label>
              </FloatLabel>
            </div>
          )}
          {admissionForm.referralType === 'other' && (
            <div className="grid grid-cols-2 md:grid-cols-2 gap-6" >
              <div className="card flex justify-content-center">
                <FloatLabel>
                  <InputText id="referralName" value={admissionForm.referralName} onChange={(e) => setAdmissionForm({ ...admissionForm, referralName: e.target.value })} style={{ width: "130px" }} />
                  <label htmlFor="referralName"> Name</label>
                </FloatLabel>
              </div>
              <div className="card flex justify-content-center">
                <FloatLabel>
                  <InputText value={admissionForm.referralPhone} onChange={(e) => setAdmissionForm({ ...admissionForm, referralPhone: e.target.value.replace(/\D/g, '') })} className="w-full" required style={{ width: "130px" }} />
                  <label htmlFor="referralPhone">MobileNo</label>
                </FloatLabel>
              </div>
            </div>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{  marginTop: "15px" }}>
          <div  >
            <label className="block text-sm font-medium text-gray-700 mb-2">Student Photo (Optional)</label>
            <FileUpload name="photo" accept="image/*" maxFileSize={1000000}
              onSelect={async (e) => {
                const file = e.files[0];
                try {
                  const base64 = await convertToBase64(file);
                  setAdmissionForm({ ...admissionForm, imageUrl: base64 });
                } catch (error) {
                  console.error('Error converting file to base64:', error);
                  toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to process image' });
                }
              }}
              onRemove={() => setAdmissionForm({ ...admissionForm, image: null })}
              emptyTemplate={<p className="m-0">Drag and drop student photo here or click to choose.</p>}
              chooseLabel="Choose Photo" uploadLabel="Upload" cancelLabel="Cancel" />
          </div>
          <div className="card flex justify-content-center">
            <FloatLabel>
              <InputTextarea id="notes" value={admissionForm.notes} onChange={(e) => setAdmissionForm({ ...admissionForm, notes: e.target.value })} style={{ width: "260px" }} />
              <label htmlFor="notes">Notes</label>
            </FloatLabel>
          </div>
        </div>

      </div>

    </Dialog >

  );
};

export default AdmissionFormDialog;
